import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseComponent} from '../../base/base.component';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../service/user.service';
import {
    CreateAreaGQL, Frame, GetUsersGQL, GetUsersQuery, RemoveAreaGQL,
    SearchAreaGQL,
    UpdateAreaGQL, User
} from '../../../generated/graphql';
import {ExcelService} from "../../service/excel.service";
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { FrameProps } from 'src/app/util/frames-and-lines';
import { QueryRef } from 'apollo-angular';

declare var $: any;

@Component({
    selector: 'app-frame',
    templateUrl: './frame.component.html',
    styleUrls: ['./frame.component.scss']
})
export class FrameComponent extends BaseComponent implements OnInit, OnDestroy {
    user: User = new User();
    modelFrame: Frame = new Frame();
    getUsersQuery: QueryRef<GetUsersQuery>;
    listUsers: User[] = [];

    frames
    frame
    
    buttonExcel: boolean;
    editFrame: boolean;
    addFrame: boolean;
    deleteFrame: boolean;

    keyword: string


    constructor(public router: Router,
                public loading: NgxSpinnerService,
                public userService: UserService,
                public translate: TranslateService,
                public searchAreaGQL: SearchAreaGQL,
                public createAreaGQL: CreateAreaGQL,
                public updateAreaGQL: UpdateAreaGQL,
                public removeAreaGQL: RemoveAreaGQL,
                public excelService: ExcelService,
                public getUsersGQL: GetUsersGQL,
                public http: HttpClient,
    ) {
        super(router, loading, translate);
    }

    ngOnInit(): void {
        this.userService.user.subscribe({
            next: data => {
                this.user = data as User;
                this.userProfile();
            }, error: err => super.onError(err)
        });
        this.getAllFrames();
        this.actionListUsers();
    }

    ngOnDestroy(): void {
        const el = $('#modalArea');
        if (el[0]) {
            el.remove();
        }
    }

    getAllFrames() {
        this.http.get(`${environment.base_url}/frame${this.keyword ? `?name=${this.keyword}`: ''}`).subscribe(
          (response: FrameProps[]) => {
            this.frames = response.map((item) => {
              return {
                id: item.id,
                name: item.name,
                manager: item.manager ?? undefined
              }
            })
            this.loading.hide()
          },
          (error) => {
            this.loading.hide()
            this.onError(error)
          }
        )
    }

    createFrame() {
        this.http.post(`${environment.base_url}/frame`, this.modelFrame).subscribe(
          (response) => {
            this.showMessage('Sucesso', 'Sucesso ao criar um quadro.', 'success')
            setTimeout(() => {
                window.location.reload()
            }, 1500);
          },
          (error) => {
            this.onError(error)
          }
        )
    }

    showModalThisCreateFrame() {
        this.modelFrame = Object.assign({});
        super.showModal('modalArea');
    }

    updateFrame(id: string) {
        this.http.put(`${environment.base_url}/frame/${id}`, this.modelFrame).subscribe(
            (response) => {
                this.showMessage('Sucesso', 'Sucesso ao atualizar um quadro.', 'success')
                setTimeout(() => {
                    window.location.reload()
                }, 1500)
            },
            (error) => {
              this.onError(error)
            }
          )
    }

    showModalThisUpdateFrame(frame: FrameProps) {
        this.modelFrame = Object.assign({}, frame);
        super.showModal('modalArea');
    }

    removeFrame(id: string) {
        super.confirmMessage(this.translate.instant('baseComponent.warningAttention'), this.translate.instant('baseComponent.warningDeleteFrame'), () => {
            this.http.delete(`${environment.base_url}/frame/${id}`).subscribe(
                (response) => {
                    this.showMessage('Sucesso', 'Quadro deletado com sucesso.', 'success')
                    setTimeout(() => {
                        window.location.reload()
                    }, 1500);
                },
                (error) => {
                  this.onError(error)
                }
              )
        });
    }

    onSave() {
        const arrValidateFields = [
            {value: this.modelFrame.name, text: 'Nome do quadro<br>'},
            {value: this.modelFrame.manager, text: 'Responsável pelo quadro<br>'},
        ];
        const stringError = this.validateField(arrValidateFields);

        if (!super.isNullOrUndefined(stringError)) {
            this.showMessage(this.translate.instant('baseComponent.warningAttention'), `${this.translate.instant('baseComponent.warningCorrectFields')} <br> ${stringError}`);
            return;
        }
        super.isNullOrUndefined(this.modelFrame.id) ? this.createFrame() : this.updateFrame(this.modelFrame.id);
        
    }

    onSearch() {
        this.loading.show()
        this.getAllFrames()
    }

    actionExcel() {
        this.loading.show();
        this.excelService.getExcelFrame(this.keyword).subscribe({
            next: data => {
                this.downloadHandlerFile(data);
                this.loading.hide();
            }, error: err => super.onError(err)
        });
    }

    actionListUsers() {
        this.getUsersQuery = this.getUsersGQL.watch();
        this.getUsersQuery.valueChanges.subscribe(({data}) => {
            this.listUsers = data.getUsers as User[];
        });
    }

    userProfile() {
        this.user.role === 'committee-member' ? (
            this.buttonExcel = false,
            this.addFrame = false,
            this.editFrame = false,
            this.deleteFrame = false
        ) : (
            this.buttonExcel = true,
            this.addFrame = true,
            this.editFrame = true,
            this.deleteFrame = true
        )
            
        
    }
}
